import mobileSchema from './mobileSchema';
import emailSchema from './emailSchema';
import { idPassportSchema, idPassportPageSchema, scanningPageSchema } from './idPassportSchema';
import {
  clientDetailSchema, clientDetailPageSchema, qualifiedInvestorSchema, typeOfInvestmentSchema, investedAmountSchema,
} from './clientDetailSchema';
import {
  bankFieldsSchema, bankDetailPageSchema, otherBankSchema, domicileCountrySchema,
} from './bankDetailsSchema';
import { sourceOfWealthPageSchema, sourceOfWealthScheme, otherSourceOfWealthSchema } from './sourceOfWealthScheme';
import { pepFieldsSchema, pepListSchema, pepPageSchema } from './pepSchema';
import { asiPageSchema, asiFieldsSchema } from './asiSchema';
import fatcaSchema from './fatcaSchema';
import crsSchema from './crsSchema';
import countryTaxSchema from './countryTaxSchema';
import formAgreementSchema from './formAgreementSchema';
import { clientProfileFormSchema, clientProfilePageSchema, insiderListSchema } from './clientProfileFormSchema';

import contractSchema from './contractSchema';

/**
 * General error message handler
 * @param {*} values
 * @param {*} schema
 */
const getErrorMessages = (values, schema) => {
  try {
    schema.validateSync(values, { abortEarly: false });
    return [];
  } catch (error) {
    return error.errors;
  }
};

const validation = {
  getErrorMessages,
  mobileSchema,
  emailSchema,

  idPassportSchema,
  idPassportPageSchema,
  scanningPageSchema,

  clientDetailSchema,
  clientDetailPageSchema,
  qualifiedInvestorSchema,
  typeOfInvestmentSchema,
  investedAmountSchema,

  pepFieldsSchema,
  pepListSchema,
  pepPageSchema,

  bankFieldsSchema,
  bankDetailPageSchema,
  otherBankSchema,
  domicileCountrySchema,

  sourceOfWealthPageSchema,
  sourceOfWealthScheme,
  otherSourceOfWealthSchema,

  asiPageSchema,
  asiFieldsSchema,

  fatcaSchema,
  crsSchema,
  countryTaxSchema,

  contractSchema,
  formAgreementSchema,

  clientProfileFormSchema,
  clientProfilePageSchema,
  insiderListSchema,
};

export default validation;
